export default __webpack_public_path__ + "static/media/Logo-my.8c4b2fd2.svg";